<template>
    <section class="card mb-2">
        <FormSection title="Supply" :full-height="false">
            <template #content>
                <div class="row p-2">
                    <div class="col-12 col-md-6" v-if="isEditAllowed">
                        <div class="form-group row">
                            <label
                                for="medicare-number"
                                class="col-form-label col-12 col-md-5 text-md-end text-sm-start"
                                >Select Supply
                            </label>
                            <div class="col-12 col-md-7">
                                <TypeaheadInput
                                    :getData="getSupplyList"
                                    :value="selectionSupply"
                                    :disabled="showSupplyInputRow"
                                    :character-limit="3"
                                    v-on:valueChanged="selectionSupplyChanged"
                                ></TypeaheadInput>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <table class="table table-responsive-md border border-gray">
                            <thead>
                                <tr class="bg-table-header">
                                    <th>Equipment Name</th>
                                    <th>Unit Cost</th>
                                    <th>Formulary</th>
                                    <th>Related</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th class="text-end">Actions</th>
                                </tr>
                            </thead>
                            <!-- EMPTY -->
                            <tbody v-if="supplies.length == 0 && !showSupplyInputRow">
                                <TableEmpty :col-span="columns" component="supply" secondary-message="No Supply Added">
                                </TableEmpty>
                            </tbody>
                            <!-- NEW -->
                            <tbody v-if="showSupplyInputRow">
                                <SupplyTableRow
                                    :supply="savetoAdd"
                                    :is-new-supply="true"
                                    :update-supply="saveNewSupply"
                                    :is-edit-allowed="isEditAllowed"
                                    :cancel-new-supply="cancelNewSupply"
                                    :columns="columns"
                                ></SupplyTableRow>
                            </tbody>
                            <!-- DATA -->
                            <tbody>
                                <SupplyTableRow
                                    v-for="supply in supplies"
                                    :supply="supply"
                                    :is-edit-allowed="isEditAllowed"
                                    :update-supply="updateSupply"
                                    :delete-supply-from-list="deleteSupplyFromList"
                                    :columns="columns"
                                >
                                </SupplyTableRow>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>
        </FormSection>
    </section>
</template>

<script lang="ts" src="./PatientSupply.ts"></script>
